$(document).ready(function () {

  /* =================================================================
     PART 1: SHOW MORE LOGIC (CRITICAL FIX FOR AJAX RELOAD)
     Keeps the "Show More" button state consistent even after Shopify 
     re-renders the variant section.
  ================================================================= */
  
  // 1. Global State Variable
  // Tracks if the user has expanded the list. 
  // false = Collapsed (Default), true = Expanded
  window.isVariantExpanded = false;

  // 2. Function to Enforce State
  // This runs immediately after Shopify re-renders the HTML
  function enforceExpandedState() {
      const $fieldset = $('fieldset.variant-featured_image-custom');
      const $button = $('.js-show-more-variants');

      // Exit if element doesn't exist
      if ($fieldset.length === 0) return;

      if (window.isVariantExpanded === true) {
          // STATE: EXPANDED
          // Even if the new HTML has the '.collapsed' class, remove it immediately.
          if ($fieldset.hasClass('collapsed')) {
              $fieldset.removeClass('collapsed');
          }
          // Hide the "Show More" button as it is no longer needed
          $button.hide();
      } else {
          // STATE: COLLAPSED (Default)
          // Ensure the class exists
          if (!$fieldset.hasClass('collapsed')) {
              $fieldset.addClass('collapsed');
          }
          // Ensure button is visible
          $button.show();
      }
  }

  // 3. Click Event Handler
  // Use event delegation on 'body' to catch clicks even after re-renders
  $('body').on('click', '.js-show-more-variants', function(e) {
      e.preventDefault(); 
      
      // Update global state
      window.isVariantExpanded = true;
      
      // Apply changes immediately
      enforceExpandedState();
  });

  // 4. MutationObserver
  // Watches the DOM for changes (Shopify AJAX updates)
  const observer = new MutationObserver(function(mutations) {
      let contentChanged = false;
      
      mutations.forEach(function(mutation) {
         if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
             const $target = $(mutation.target);
             
             // Check if the variant section was updated
             if ($target.find('.variant-featured_image-custom').length > 0 || 
                 $target.hasClass('variant-featured_image-custom') ||
                 $target.closest('variant-selects').length > 0) {
                 contentChanged = true;
             }
         }
      });

      if (contentChanged) {
          // DOM updated -> Re-apply the expanded state immediately
          enforceExpandedState();
          
          // Re-calculate the index, BUT DO NOT SHOW THE IMAGE
          updateIndexOnly();
      }
  });

  // Observe the body for changes
  observer.observe(document.body, { childList: true, subtree: true });

  // Initial Run
  enforceExpandedState();


  /* =================================================================
     PART 2: IMAGE SLIDER & PREVIEW LOGIC
     (Modified to be HIDDEN on load, SHOWN only on change)
  ================================================================= */
  
  let isNavigating = false;    
  let lastIndex = -1;          
  const $preview = $('#variant-image-preview');

  // Safety check
  if ($preview.length === 0) return;
  
  // [CRITICAL CHANGE] Always hide on load
  $preview.hide(); 

  // --- Helper: Update Index Only (Silent) ---
  // This calculates the current index so navigation works, 
  // but it DOES NOT show the image.
  function updateIndexOnly() {
      const $checked = $('fieldset.variant-featured_image-custom input[type="radio"]:checked');
      if ($checked.length > 0) {
          const groupName = $checked.attr('name');
          const $allRadios = $(`input[type="radio"][name="${groupName}"][data-full-img]`);
          lastIndex = $allRadios.index($checked);
      }
  }

  // --- Main: Update Preview (Visual) ---
  // This is only called when the user interacts (clicks/changes)
  function updatePreviewImage($input) {
    try {
        const fullImg = $input.attr('data-full-img');
        if (!fullImg) return; 

        const groupName = $input.attr('name');
        const $allRadios = $(`input[type="radio"][name="${groupName}"][data-full-img]`);
        const currentIndex = $allRadios.index($input);

        // A. Initial Render (Create HTML if empty)
        if ($preview.find('.preview-content').length === 0) {
            $preview.html(`
            <span class="preview-nav preview-prev">❮</span>
            <div class="preview-content"><img src="${fullImg}" class="variant-full-image active-slide"></div>
            <span class="preview-nav preview-next">❯</span>
            `);
            // Show the container now that the user interacted
            $preview.fadeIn(200);
            lastIndex = currentIndex;
            return;
        }

        // B. Slide Animation
        const $container = $preview.find('.preview-content');
        const $currentImg = $container.find('img.active-slide');

        // Identify current image src safely
        const currentSrc = $currentImg.attr('src') || '';

        // Check if image is effectively the same (avoids protocol issues)
        if (currentSrc.indexOf(fullImg) !== -1 || fullImg.indexOf(currentSrc) !== -1) {
             if (!$preview.is(':visible')) $preview.fadeIn(200);
             return;
        }

        let direction = 'next';
        if (lastIndex !== -1) {
            if (currentIndex < lastIndex) direction = 'prev';
            // Loop logic (First -> Last, Last -> First)
            if (lastIndex === $allRadios.length - 1 && currentIndex === 0) direction = 'next';
            if (lastIndex === 0 && currentIndex === $allRadios.length - 1) direction = 'prev';
        }

        const $newImg = $(`<img src="${fullImg}" class="variant-full-image">`);
        $newImg.css('transform', direction === 'next' ? 'translateX(100%)' : 'translateX(-100%)');
        $container.append($newImg);
        
        // Force Reflow
        void $newImg[0].offsetWidth; 

        const transitionCSS = { 'transition': 'transform 0.4s ease-out' };
        $currentImg.css(transitionCSS);
        $newImg.css(transitionCSS);

        if (direction === 'next') {
            $currentImg.css('transform', 'translateX(-100%)');
            $newImg.css('transform', 'translateX(0%)');
        } else {
            $currentImg.css('transform', 'translateX(100%)');
            $newImg.css('transform', 'translateX(0%)');
        }

        // Cleanup after animation
        setTimeout(() => {
            $currentImg.remove();
            $newImg.addClass('active-slide').css('transition', '');
        }, 400);

        lastIndex = currentIndex;
        
        // [CRITICAL] Ensure it becomes visible on interaction
        if (!$preview.is(':visible')) $preview.fadeIn(150);

    } catch (e) { console.error(e); }
  }

  // --- Navigation Logic ---
  function navigateVariant(direction) {
    if (isNavigating) return; 
    isNavigating = true;

    // Find currently checked input
    const $currentRadio = $('fieldset.variant-featured_image-custom input[type="radio"]:checked');
    if (!$currentRadio.length) { isNavigating = false; return; }

    const groupName = $currentRadio.attr('name');
    const $allRadios = $(`input[type="radio"][name="${groupName}"][data-full-img]`);
    
    let currentIndex = $allRadios.index($currentRadio);
    let newIndex = (direction === 'next') ? currentIndex + 1 : currentIndex - 1;

    // Loop bounds
    if (newIndex >= $allRadios.length) newIndex = 0;
    if (newIndex < 0) newIndex = $allRadios.length - 1; 

    const $targetRadio = $allRadios.eq(newIndex);
    updatePreviewImage($targetRadio); // Shows image
    
    // Trigger change to update Shopify form
    $targetRadio.prop('checked', true).trigger('change');
    
    setTimeout(() => { isNavigating = false; }, 300);
  }

  // --- Event Listeners ---
  $preview.on('click', '.preview-next', function(e) { e.stopPropagation(); navigateVariant('next'); });
  $preview.on('click', '.preview-prev', function(e) { e.stopPropagation(); navigateVariant('prev'); });

  // Swipe Logic (Mobile)
  let touchStartX = 0;
  $preview.on('touchstart', function(e) { touchStartX = e.changedTouches[0].screenX; });
  $preview.on('touchend', function(e) { 
      if (touchStartX - e.changedTouches[0].screenX > 50) navigateVariant('next');
      if (e.changedTouches[0].screenX - touchStartX > 50) navigateVariant('prev');
  });

  // --- Initialization ---
  // [CRITICAL CHANGE] We do NOT call updatePreviewImage here.
  // We only calculate the index silently. The preview remains hidden.
  updateIndexOnly();
  setTimeout(updateIndexOnly, 100);

  
  // Watch for radio changes (using delegation)
  // This is what triggers the image to appear (updatePreviewImage contains fadeIn)
  $(document).on('change', 'input[type="radio"][data-full-img]', function () {
      if (!isNavigating) {
          updatePreviewImage($(this));
      }
  });

  // Lightbox Logic
  let mouseStartX = 0;
  $preview.on('mousedown', function(e) { mouseStartX = e.clientX; });
  
  $(document).on('click', '#variant-image-preview img', function (event) {
    if (Math.abs(mouseStartX - event.clientX) > 10) return; // Ignore drag events
    const src = $(this).attr('src');
    if (!src) return;
    $('#variant-lightbox img').attr('src', src);
    $('#variant-lightbox').fadeIn(200);
  });

  $(document).on('click', '.lightbox-close, #variant-lightbox', function (e) {
    if (e.target !== this) return;
    $('#variant-lightbox').fadeOut(200);
  });

});